import * as types from '../actions/action-types';

const initialState = {};

const genericBillingAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INITIALISE_BILLING_ADDRESS:
      if (action.paymentOptions?.length > 0) {
        let newState = state;
        action.paymentOptions.forEach((option) => {
          newState = {
            ...newState,
            [option]: {
              useShippingAddress: true,
              country: action.country,
            },
          };
        });
        return newState;
      }
      return state;
  
    case types.INITIALISE_BILLING_ADDRESS_BY_PAYMENT_OPTION_TYPE:
      if (action.paymentOptionType) {
        return {
          ...state,
          [action.paymentOptionType]: {
            useShippingAddress: true,
            country: action.country,
          },
        };
      }
      return state;
    
    case types.UPDATE_BILLING_ADDRESS_BY_PAYMENT_METHOD:
      if (state[action.paymentMethod]) {
        return {
          ...state,
          [action.paymentMethod]: {
            ...state[action.paymentMethod],
            [action.fieldName]: action.fieldValue,
          },
        };
      }
      
      return {
        ...state,
        [action.paymentMethod]: {
          [action.fieldName]: action.fieldValue,
        },
      };
  
    case types.OVERWRITE_BILLING_ADDRESS_BY_PAYMENT_METHOD:
      if (state[action.paymentMethod]) {
        return {
          ...state,
          [action.paymentMethod]: {
            ...state[action.paymentMethod],
            ...action.payload,
          },
        };
      }
    
      return {
        ...state,
        [action.paymentMethod]: {
          ...action.payload,
        },
      };
      
    default:
      return state;
  }
};

export default genericBillingAddressReducer;
